const translations = {
  "en": {
    "DEA:": "DEA:",
    "DIF:": "DIF:",
    "MACD:": "MACD:",
    "MACD(12, 26, 9)": "MACD(12, 26, 9)"
  },
  "zh-tw": {
    "DEA:": "DEA:",
    "DIF:": "DIF:",
    "MACD:": "MACD:",
    "MACD(12, 26, 9)": "MACD(12, 26, 9)"
  }
};

export default translations;
